import enHistory from "./en";
import frHistory from "./fr";
import ptHistory from "./pt";
import spHistory from "./sp";

const contentsHistory ={
    pt:ptHistory,
    en:enHistory,
    fr:frHistory,
    sp:spHistory
};

export default contentsHistory;